import { render, staticRenderFns } from "./CompareSkill.vue?vue&type=template&id=234f54f6&scoped=true&"
import script from "./CompareSkill.vue?vue&type=script&lang=js&"
export * from "./CompareSkill.vue?vue&type=script&lang=js&"
import style0 from "./CompareSkill.vue?vue&type=style&index=0&id=234f54f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234f54f6",
  null
  
)

export default component.exports